import React, { Component } from "react";
import {Modal, Card, Form, Button, Row, Col, Table, Alert, Tab, Tabs, InputGroup, OverlayTrigger, Tooltip, ListGroup, FormLabel, CardBody} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { categoriasDeGraficos } from '../../common/utils';
import Paginacao from '../../common/pagination';
import { FaEdit, FaTrash, FaArrowUp, FaArrowDown } from "react-icons/fa";
import '../ProgramasV2/ProgramasEdit.module.css';

class MotivosOptout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            motivos_optout: [],
            motivoSelecionado: [{titulo: "", ordem: ''}],
            programa_id: this.props.programa_id,
            erroLoadRegistro: '',
            loading: false,
            page_numb: this.props.page_numb || 1,
            page_limit: this.props.page_limit || 50
        }
    }

    componentDidMount() {
        this.carregarMotivosOptout();
    }

    carregarMotivosOptout = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/optout-motivos/?programa_id=${this.state.programa_id}&page=${this.state.page_numb}&page_limit=${this.state.page_limit}`)
            .then(response => {
                this.setState({
                    motivos_optout: {
                        ...response.data,
                        results:response.data.results.map(optout => ({
                            id: optout.id,
                            titulo: optout.titulo,
                            ordem: optout.ordem
                        }))
                    }
                });
            })
            .catch(error => {
                console.error('Erro ao carregar motivos de optout:', error);
                
                let erro_msg = 'Erro ao carregar motivos de optout, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
    }

    handleMotivoOptoutChange = (e, fieldName) => {
        const { name, value } = e.target;
        this.setState({ motivoSelecionado: { ...this.state.motivoSelecionado, [name]: value } });
    }

    moverMotivoOptout = (index, direcao) => {
        let novosMotivos = [...this.state.motivos_optout.results];
        let motivoMovido = { ...novosMotivos[index] };
    
        if (direcao === 'up' && index > 0) {
            // Troca a etapa atual com a anterior
            novosMotivos[index] = novosMotivos[index - 1];
            novosMotivos[index - 1] = motivoMovido;
            // Atualiza a ordem (index baseado em 1 para a ordem)
            novosMotivos[index].ordem = index + 1;
            novosMotivos[index - 1].ordem = index;
        } else if (direcao === 'down' && index < novosMotivos.length - 1) {
            // Troca a etapa atual com a seguinte
            novosMotivos[index] = novosMotivos[index + 1];
            novosMotivos[index + 1] = motivoMovido;
            // Atualiza a ordem
            novosStatus[index].ordem = index + 1;
            novosStatus[index + 1].ordem = index + 2;
        }
    
        // Atualiza o estado
        this.setState({ motivos_optout: { ...this.state.motivos_optout, results: novosMotivos } }, () => {
            // Salva a etapa movida com a nova ordem
            this.handleSalvarMotivoOptout(index + (direcao === 'down' ? 1 : -1));
            // Salva a etapa que foi substituída pela movida, para atualizar sua ordem
            this.handleSalvarMotivoOptout(index);
        });
    };

    handleSalvarMotivoOptout = async (index = null) => {
        const formData = new FormData();
        const motivo = index !== null ? this.state.motivos_optout.results[index] : this.state.motivoSelecionado;
        let url = '';
        let metodo = '';

        if(index !== null){
            url = `/programas/optout-motivos/${this.state.motivos_optout.results[index].id}/`;    
            metodo = 'put';
        } else {
            url = motivo.id ? `/programas/optout-motivos/${motivo.id}/` : '/programas/optout-motivos/';
            metodo = motivo.id ? 'put' : 'post';
        }

        const dadosMotivoOptout = {
            titulo: motivo.titulo,
            ordem: motivo.ordem,
            programa_id: this.state.programa_id
        };

        if(index){
            dadosMotivoOptout['ordem'] = index + 1;
        } else {
            dadosMotivoOptout['ordem'] = motivo.ordem || this.state.motivos_optout.results.length + 1;
        }
        api({
            method: metodo,
            url: url,
            data: dadosMotivoOptout,
        })
        .then(response => {
            
            if(index == null){
                const MySwal = withReactContent(Swal)
                const textSwal = (this.state.motivoSelecionado.id) ? 'Motivo de optout atualizado com sucesso' : 'Motivo de optout cadastrado com sucesso';

                MySwal.fire({
                    title: <p>{textSwal}</p>,
                    icon: 'success',
                    showCloseButton: true,
                })

                this.carregarMotivosOptout();
                this.handleCloseModalMotivoOptout();
            }
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o motivo de optout, verifique os campos e tente novamente';         
            let content = '';   

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'titulo') {
                        content += `<br>&bull; Título: ${value}`;
                    }
                    if(key == 'programa_id') {
                        content += `<br>&bull; Id do programa: ${value}`;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    }

    removerMotivoOptout = (motivo) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover motivo de optout?',
            text: "Tem certeza que deseja remover o motivo de optout " + motivo.titulo + "?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                if (motivo.id) {
                    api({
                        method: 'delete',
                        url: `/programas/optout-motivos/${motivo.id}/`,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Motivo de optout removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.carregarMotivosOptout();
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o motivo de optout, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        motivos_optout: prevState.motivos_optout.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O motivo de optout foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    handleShowModalMotivoOptout = (motivo = []) => {
        this.setState({ showModalMotivoOptout: true, motivoSelecionado: motivo });
    }

    handleCloseModalMotivoOptout = () => {
        this.setState({ showModalMotivoOptout: false, motivoSelecionado: []});
    }

    onClickPaginaMotivoOptout = (num_page) => {
        this.setState({
            loading: true,
            page_numb: num_page
        }, () => {
            this.carregarMotivosOptout(num_page)
        });
    };


    render() {
        return (
            <>
            <Card className="cardDestaque mt-4">
                <Card.Body>                   
                    <Row className="align-items-center mb-3">
                        <Col sm={6} lg={6}>
                            <h6><strong>Motivos de Optout</strong></h6>
                        </Col>
                        <Col sm={6} xs={6} className="text-end">                       
                            <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModalMotivoOptout()}>
                                {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Adicionar Motivo de Optout'}                                       
                            </Button>
                        </Col>
                    </Row>
                    {('results' in this.state.motivos_optout && this.state.motivos_optout.results.length > 0) ? (
                        <Row>
                            <Col sm={12} lg={12}>
                                <Table responsive className="custom-table">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Título</th>
                                            <th>Ordem</th>
                                            <th>Opções</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.motivos_optout.results.map((motivo, index) => ( 
                                            <tr key={index}>
                                                <td className="bg-id">#{motivo.id}</td>
                                                <td className="td-border">{motivo.titulo}</td>
                                                <td className="td-border">{motivo.ordem}
                                                    {motivo.id && index > 0 && (
                                                        <Button variant="outline-primary" className="btn-sm me-2" onClick={() => this.moverMotivoOptout(index, 'up')}><FaArrowUp /></Button>
                                                    )}
                                                    {motivo.id && index < this.state.motivos_optout.results.length - 1 && (
                                                        <Button variant="outline-primary" className="btn-sm" onClick={() => this.moverMotivoOptout(index, 'down')}><FaArrowDown /></Button>
                                                    )}
                                                </td>
                                                <td>
                                                    <Button variant="secondary" size="sm" className="me-2" onClick={() => this.handleShowModalMotivoOptout(motivo)}>
                                                        <FaEdit /> Editar
                                                    </Button>  
                                                    <Button variant="danger" size="sm" className="me-2" onClick={() => this.removerMotivoOptout(motivo)}>
                                                        <FaTrash /> Remover
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                    {'results' in this.state.motivos_optout && this.state.motivos_optout.results.length > 0 && (
                                        <Paginacao dados={this.state.motivos_optout} limit={this.state.page_limit} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPaginaMotivoOptout} />
                                    )}
                            </Col>
                        </Row>   
                    ) : (
                        <p>Nenhum motivo de optout cadastrado até o momento</p>
                    )}
                            
                </Card.Body>                
            </Card>

            <Modal show={this.state.showModalMotivoOptout} onHide={this.handleCloseModalMotivoOptout} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {this.state.motivoSelecionado.id ? 'Editar Motivo de Optout #' + this.state.motivoSelecionado.id : 'Adicionar Motivo de Optout'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <h4>Motivo de Optout</h4>
                            <div className="row-list">
                                <Row>                                                
                                    <Col sm={4} xs={12}>
                                        <Form.Group>
                                            <Form.Label>Título</Form.Label>   
                                            <Form.Control 
                                                type="text"                                                             
                                                name="titulo"
                                                value={this.state.motivoSelecionado.titulo} 
                                                onChange={(e) => this.handleMotivoOptoutChange(e, "titulo")}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3} xs={12}>
                                        <Form.Group>
                                            <Form.Label>Ordem</Form.Label>   
                                            <Form.Control 
                                                type="number"                                                             
                                                name="ordem"
                                                value={this.state.motivoSelecionado.ordem} 
                                                onChange={(e) => this.handleMotivoOptoutChange(e, "ordem")}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleCloseModalMotivoOptout}>
                        Fechar
                    </Button>
                    <Button variant="primary" onClick={() => this.handleSalvarMotivoOptout()}>
                        Salvar
                    </Button>
                </Modal.Footer>
            </Modal>
            </>
        );
    }
}

export default MotivosOptout;

